import { useContext } from 'react';
import { Link } from 'react-router-dom';

import { MultiStepFormContext } from '@kanda-libs/ks-component-ts';
import { Button, DesktopLayoutBoxed } from '@kanda-libs/ks-design-library';

import Copyright from 'components/Copyright';
import ExampleJobAlertBanner from 'components/ExampleJobAlertBanner';
import useHelpModal from 'components/HelpModal/useHelpModal';
import MultiStepFormStepSidebar from 'components/MultiStepFormStepSidebar';
import { URLS } from 'config';

import { CLASS_NAMES, TITLE } from './constants';

import Footer from '../Footer';

interface DesktopProps {
  children: JSX.Element;
  showOuterLayout?: boolean;
  nextButtonProps?: {
    disabled?: boolean;
  };
  isSubmitting?: boolean;
  showExampleBanner?: boolean;
}

const Desktop = ({
  nextButtonProps,
  showOuterLayout,
  isSubmitting,
  showExampleBanner = true,
  children,
}: DesktopProps) => {
  const { data } = useContext(MultiStepFormContext);
  const { showHelpModal } = useHelpModal();

  const jobId = data?.job?.id;

  const content = (
    <>
      {showExampleBanner && <ExampleJobAlertBanner />}
      {children}
      {showOuterLayout && (
        <Footer
          isDesktop
          nextButtonProps={nextButtonProps}
          isSubmitting={isSubmitting}
        />
      )}
    </>
  );

  return (
    <>
      <DesktopLayoutBoxed
        help={showHelpModal}
        layoutFooter={<Copyright />}
        options={[
          <Link key="close" to={URLS.job.replace(':id?', jobId)}>
            <Button.Icon id="apply-for-finance-close" icon="close" />
          </Link>,
        ]}
      >
        <>
          {showOuterLayout && (
            <MultiStepFormStepSidebar>{content}</MultiStepFormStepSidebar>
          )}
          {!showOuterLayout && content}
        </>
      </DesktopLayoutBoxed>
      <p className={CLASS_NAMES.title}>{TITLE}</p>
    </>
  );
};

Desktop.defaultProps = {
  showOuterLayout: true,
  nextButtonProps: {},
  isSubmitting: false,
};

export default Desktop;
